<template>
    <LiefengContent>
        <template v-slot:title>{{ $route.query.userName + $route.query.mobile }} - 积分详情</template>
        <template v-slot:contentArea>
            <div class="leftMenu">
                <div style="margin-bottom: 16px;">
                    <Button 
                        type="error" 
                        :disabled="selectedRows.length === 0"
                        @click="batchDelete"
                    >
                        批量删除 ({{ selectedRows.length }})
                    </Button>
                </div>
                <LiefengTable
                    :talbeColumns="tableColumns"
                    :tableData="menuList"
                    :loading="loading"
                    :fixTable="true"
                    :curPage="page"
                    :total="total"
                    :pagesizeOpts="[20, 30, 50, 100]"
                    :page-size="pageSize"
                    @hadlePageSize="hadlePageSize"
                    @tableSelect="handleSelectionChange"
                ></LiefengTable>
            </div>
        </template>
    </LiefengContent>
</template>

<script>
//@route('/test15minmanage')
import LiefengContent from "@/components/LiefengContent3"
import LiefengTable from "@/components/LiefengTable"
export default {
    components: {
        LiefengContent,
        LiefengTable,
    },
    data() {
        return {
            page: 1,
            pageSize: 20,
            total: 0,
            loading: false,
            menuList: [],
            selectedRows: [], // 选中的行数据
            tableColumns: [
                {
                    type: "selection",
                    width: 60,
                    align: "center",
                },
                {
                    title: "任务名称",
                    width: 250,
                    key: "taskName",
                    align: "center",
                },
                {
                    title: "积分",
                    minWidth: 200,
                    key: "pointsCount",
                    align: "center",
                },
                {
                    title: "所属类型",
                    minWidth: 200,
                    key: "taskType",
                    align: "center",
                    render: (h, params) => {
                        return h("div", {}, params.row.taskType && params.row.taskType != "" ? (params.row.taskType == "1" ? "获取" : params.row.taskType == "2" ? "扣除" : "") : "")
                    },
                },
                {
                    title: "操作账号",
                    minWidth: 200,
                    key: "operatorMobile",
                    align: "center",
                },
                {
                    title: "备注",
                    minWidth: 200,
                    key: "remark",
                    align: "center",
                },
                {
                    title: "来源",
                    key: "source",
                    width: 170,
                    align: "center",
                    render: (h, params) => {
                        return h("div", {}, params.row.source && params.row.source != "" ? (params.row.source == "1" ? "线上" : params.row.source == "2" ? "线下" : "") : "")
                    },
                },
                {
                    title: "操作时间",
                    key: "gmtCreate",
                    width: 170,
                    align: "center",
                    render: (h, params) => {
                        return h("div", params.row.gmtCreate && params.row.gmtCreate != "" ? this.$core.formatDate(new Date(params.row.gmtCreate), "yyyy-MM-dd hh:mm:ss") : "") 
                    },
                },
                {
                    title: "操作",
                    key: "action",
                    width: 120,
                    align: "center",
                    render: (h, params) => {
                        return h(
                            "Button",
                            {
                                props: { type: "error", size: "small" },
                                on: {
                                    click: () => this.deleteRow(params.row),
                                },
                            },
                            "删除"
                        )
                    },
                },
                
            ],
        }
    },
    methods: {
        hadlePageSize(obj) {
            this.pageSize = obj.pageSize
            this.page = obj.page
            this.getList()
        },
        // 处理选中变化
        handleSelectionChange(selection) {
            console.log("选中变化触发，选中数据:", selection);
            this.selectedRows = selection;
            console.log("更新后的selectedRows:", this.selectedRows);
        },
        // 批量删除
        batchDelete() {
            if (this.selectedRows.length === 0) {
                this.$Message.error({
                    background: true,
                    content: "请选择要删除的数据",
                })
                return
            }
            
            this.$Modal.confirm({
                title: "批量删除确定",
                content: `您正在删除${this.selectedRows.length}条数据，是否继续？`,
                onOk: () => {
                    const userEventIds = this.selectedRows.map(row => row.userEventId);
                    console.log("批量删除选中的行数据:", this.selectedRows);
                    console.log("批量删除的事件ID列表:", userEventIds);
                    this.$post("/gateway/sy-points/api/sypointes/user/batchDeleteUserEventDetail", 
                        {userEventIds: userEventIds},
                        {"Content-Type": "application/json"}
                    ).then(res => {
                        if (res.code == 200) {
                            this.$Message.success({ background: true, content: "批量删除成功" })
                            this.selectedRows = []; // 清空选中
                            this.getList()
                        } else {
                            this.$Message.error({ background: true, content: res.desc || "批量删除失败" })
                        }
                    }).catch(err => {
                        this.$Message.error({ background: true, content: "批量删除失败，请联系管理员" })
                    })
                },
            })
        },
        getList() {
            this.loading = true
            this.$get("/gateway/sy-points/api/sypointes/user/listPointsUserEventDetail", {
                userId: this.$route.query.userId,
                page: this.page,
                pageSize: this.pageSize,
                orgCode: window.sessionStorage.getItem("orgCode"),
                poolCode: "P710019",
                excludeZeroPoints: true,  // 新增参数，排除积分为0的记录
            })
                .then(res => {
                    if (res.code == 200 && res.dataList) {
                        this.menuList = res.dataList
                        console.log("获取到的表格数据:", this.menuList);
                        this.page = res.currentPage
                        this.pageSize = res.pageSize
                        this.total = res.maxCount
                    }
                    this.$Message.destroy()
                    this.loading = false
                })
                .catch(err => {
                    this.loading = false
                    this.$Message.destroy()
                    this.$Message.error({
                        background: true,
                        content: "获取数据失败，请联系管理员处理",
                    })
                })
        },
        deleteRow(row) {
            if (!row || !row.userEventId) {
                this.$Message.error({
                    background: true,
                    content: "缺少必要的标识，无法删除",
                })
                return
            }
            this.$Modal.confirm({
                title: "删除确定",
                content: "您正在删除数据，是否继续？",
                onOk: () => {
                    this.$post("/gateway/sy-points/api/sypointes/user/batchDeleteUserEventDetail", 
                    {userEventIds: [row.userEventId]},
                    {"Content-Type": "application/json"}
                ).then(res => {
                        if (res.code == 200) {
                            this.$Message.success({ background: true, content: "删除成功" })
                            this.getList()
                        } else {
                            this.$Message.error({ background: true, content: res.desc || "删除失败" })
                        }
                    })
                },
            })
        },
    },
    async created() {
        this.getList()
    },
}
</script>

<style lang='less'>
/deep/.ivu-form-item-content {
    display: flex !important;
}
.ivu-form-item-label {
    display: flex !important;
}
</style>
